import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=3b694226&scoped=true"
import script from "./card-detail.vue?vue&type=script&lang=js"
export * from "./card-detail.vue?vue&type=script&lang=js"
import style0 from "./card-detail.vue?vue&type=style&index=0&id=3b694226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b694226",
  null
  
)

export default component.exports